module.exports = __webpack_public_path__ + "img/c-i1.73c66eb6.svg";